import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/roles')({
  staticData: { breadcrumb: 'Roles', breadcrumbKey: 'K_BREADCRUMB_ROLES' },
});
